import { isPlatformBrowser } from '@angular/common';
import Cookies from 'js-cookie';

export function hasValue(value: any): boolean {
  return typeof value !== 'undefined' && value !== '' && value !== null;
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function chunkArray(arr: any[], size: number): any[] {
  const myArray: any[] = [];
  for (let i = 0; i < arr.length; i += size) {
    myArray.push(arr.slice(i, i + size));
  }
  return myArray;
}

export function camelCaseConvert(str: string, join: string): string {
  const split: string[] = str.split(/(?=[A-Z])/);
  split.forEach((fragment: string, index: number) => {
    split[index] = fragment.toLowerCase();
  });

  return split.join(join);
}

/**
 * Returns the tealium visitor ID on the client
 */
export function getVisitorId(platformId: Object): string {
  const win = window as any;

  if (!isPlatformBrowser(platformId)) return '';
  if (win.utag_data !== undefined && win.utag_data.tealium_visitor_id) {
    return win.utag_data.tealium_visitor_id;
  }

  const utagMainCookie = Cookies.get('utag_main');
  if (!utagMainCookie) return '';
  const cookieParts = utagMainCookie.split('$');
  for (const part of cookieParts) {
    if (part.startsWith('v_id:')) {
      const vId = part.substring(5).split(';')[0];
      if (vId) return vId;
    }
  }

  return '';
}
